var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49 9.063c-.793 0-1.149.437-2.434.437-1.312 0-1.668-.438-2.46-.438C2.571 9.063.93 10.73.93 12.755v.684c0 .738.574 1.312 1.313 1.312h9.625c.71 0 1.312-.574 1.312-1.313v-.683c0-2.024-1.668-3.691-3.691-3.691zm2.379 4.374H2.244v-.683c0-1.313 1.039-2.379 2.351-2.379.41 0 1.04.438 2.461.438 1.395 0 2.024-.438 2.434-.438a2.38 2.38 0 0 1 2.379 2.379v.684zM7.056 8.625c2.16 0 3.938-1.75 3.938-3.938 0-2.16-1.778-3.937-3.938-3.937A3.938 3.938 0 0 0 3.12 4.688a3.921 3.921 0 0 0 3.937 3.937zm0-6.563c1.422 0 2.625 1.204 2.625 2.626 0 1.449-1.203 2.625-2.625 2.625a2.626 2.626 0 0 1-2.625-2.625c0-1.422 1.176-2.625 2.625-2.625z",
    fill: "#233145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFilter);
export default __webpack_public_path__ + "static/media/user-filter.2a6519de0ecabc6bb49db2625c2518e2.svg";
export { ForwardRef as ReactComponent };